import { classifyAiMappingError } from "./aiMappingErrors";
import { AiMappingNotify } from "./aiMappingControllerTypes";

export const unwrap = <TResult extends { data?: unknown; error?: unknown }, TData>(
  result: TResult,
  select: (data: any) => TData | null | undefined
): TData => {
  if (result.error) throw result.error;
  const data = select(result.data);
  if (!data) throw new Error("ai_mapping_unavailable");
  return data;
};

export interface TaskPayloadLike {
  taskId: string;
  area?: import("./aiMappingTypes").AiMappingAreaLike | null;
}

export async function handleAiMappingMutationFailure(
  result: unknown,
  {
    notify,
    handleError,
    unmountedRef,
    staleCodes,
    onStale,
  }: {
    notify: AiMappingNotify;
    handleError: (error: unknown, options?: { inline?: boolean }) => boolean;
    unmountedRef: React.MutableRefObject<boolean>;
    staleCodes: string[];
    onStale?: () => Promise<void>;
  }
): Promise<void> {
  if (unmountedRef.current) return;
  const info = classifyAiMappingError(result);
  if (staleCodes.includes(info.code)) {
    notify(info.message, "error");
    await onStale?.();
    return;
  }
  handleError(result);
}
